import { render, staticRenderFns } from "./CloudTransferConfig.vue?vue&type=template&id=6831d1bc&scoped=true"
import script from "./CloudTransferConfig.vue?vue&type=script&lang=js"
export * from "./CloudTransferConfig.vue?vue&type=script&lang=js"
import style0 from "./CloudTransferConfig.vue?vue&type=style&index=0&id=6831d1bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6831d1bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6831d1bc')) {
      api.createRecord('6831d1bc', component.options)
    } else {
      api.reload('6831d1bc', component.options)
    }
    module.hot.accept("./CloudTransferConfig.vue?vue&type=template&id=6831d1bc&scoped=true", function () {
      api.rerender('6831d1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/CloudTransferConfig.vue"
export default component.exports